<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Ürün Kategorileri</span>
      </b-col>

      <b-col cols="auto" class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 440">Ayarlar</span>
        </b-btn>

        <b-btn to="/Settings/Categories/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">
            <span v-if="ScreenWidth >= 350 && ScreenWidth < 380">Kat.</span>
            <span v-if="ScreenWidth >= 380">Kategori</span>
            <span class="ml-1" v-if="ScreenWidth >= 410">Ekle</span>
          </span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Categories"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Settings/Categories/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "Sort",
      sortDesc: false,
      fields: [
        { key: "Name", label: "Kategori Adı", sortable: true },
        { key: "ProductsCount", label: "Ürün Sayısı", sortable: true },
        { key: "Sort", label: "Sıralama", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Categories() {
      let _Categories = [];

      if (this.StoreData.Categories)
        for (let i in this.StoreData.Categories) {
          const _Category = this.StoreData.Categories[i];

          _Categories.push({
            ID: _Category.ID,
            Name: _Category.Name,
            ProductsCount: _Category.Products
              ? Object.keys(_Category.Products).length
              : 0,
            Sort: _Category.Sort
          });
        }

      return _Categories;
    }
  },
  methods: {
    async Go(x) {
      await this.$router.push(x);
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
